<template>
  <el-dialog
    title="Sửa hạng phòng"
    :visible.sync="dialogDetailVisible"
    :close-on-click-modal="false"
    width="700px"
    @close="
      () => {
        dialogDetailVisible = false
      }
    "
  >
    <slot>
      <validation-observer ref="formValidator">
        <div class="das-form-container datnt">
          <div class="das-form-group" style="margin-bottom: 0">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider
                  tag="div"
                  class="das-form-input"
                  rules="required"
                  name="Mã hạng phòng"
                >
                  <div class="label required">Mã hạng phòng</div>
                  <div class="child-w-80">
                    <input
                      v-model="detail.room_level_code"
                      disabled
                      type="text"
                      placeholder=""
                    />
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider
                  tag="div"
                  class="das-form-input"
                  rules="required"
                  name="Tên hạng phòng"
                >
                  <div class="label required">Tên hạng phòng</div>
                  <div class="child-w-80">
                    <input
                      v-model="detail.room_level_name"
                      disabled
                      type="text"
                      placeholder=""
                    />
                  </div>
                </validation-provider>
              </div>
            </div>
            <h3>Cấu hình Hotel Link</h3>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider
                  tag="div"
                  class="das-form-input"
                  name="Room ID"
                >
                  <div class="label">Room ID</div>
                  <div class="child-w-80">
                    <input
                      v-model="detail.room_id_hl"
                      type="text"
                      placeholder=""
                    />
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider
                  tag="div"
                  class="das-form-input"
                  name="Độ chênh lệch"
                >
                  <div class="label">Độ chênh lệch</div>
                  <div class="child-w-80">
                    <input
                      v-model="detail.difference_hl"
                      type="text"
                      placeholder=""
                    />
                  </div>
                </validation-provider>
              </div>
            </div>

            <!-- Rate Name and Rate ID Table -->
            <div>
              <GridVx
                ref="agGridRate"
                :columns="columns"
                :rows="detail.rate_plan_list"
                row-selection="single"
                class="agGrid"
                :auto-select-first-row="false"
                :auto-size-cell="true"
                :context="context"
              />
            </div>
          </div>
        </div>
      </validation-observer>
    </slot>
    <span
      slot="footer"
      class="dialog-footer"
      style="display: flex; justify-content: flex-end"
    >
      <div class="button-containers">
        <button class="btn primary small" @click="updateRoom">
          {{ 'Cập nhật' }}
        </button>
        <button
          class="btn primary small outline"
          @click="dialogDetailVisible = false"
        >
          {{ 'Đóng' }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { updateHotelLinkDetail } from '@/api/config-service/hotel-link'
import {
  CellRenderDeleteIcon,
  CellRenderTextInput,
  CellHeaderAddIcon
} from '@/utils/cellRenders.js'
export default {
  components: {
    CellRenderTextInput,
    CellRenderDeleteIcon,
    CellHeaderAddIcon
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    selectedRow: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogDetailVisible: false,

      detail: {
        room_level_code: null,
        room_level_name: null,
        room_id_hl: null,
        difference_hl: null,
        rate_plan_list: []
      },

      context: null
    }
  },
  computed: {
    columns() {
      return [
        {
          headerName: 'Rate Name',
          field: 'rate_plan_name_hl',
          minWidth: 150,
          cellRenderer: 'CellRenderTextInput',
          cellRendererParams: () => {
            return {
              type: 'text',
              colName: 'rate_plan_name_hl'
            }
          }
        },
        {
          headerName: 'Rate ID',
          field: 'rate_plan_id_hl',
          minWidth: 100,
          cellRenderer: 'CellRenderTextInput',
          cellRendererParams: () => {
            return {
              type: 'text',
              colName: 'rate_plan_id_hl'
            }
          }
        },
        {
          headerName: '',
          width: 50,
          cellRenderer: 'CellRenderDeleteIcon',
          headerComponent: 'CellHeaderAddIcon',
          cellStyle: () => {
            return {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }
          }
        }
      ]
    }
  },
  watch: {
    value(nv, ov) {
      this.dialogDetailVisible = nv
    },
    dialogDetailVisible(nv, ov) {
      if (!nv) {
        this.$emit('input', nv)
      } else {
        this.initData()
      }
    }
  },

  methods: {
    initData() {
      this.context = { componentParent: this }
      this.detail = JSON.parse(JSON.stringify(this.selectedRow))
      if (this.detail?.rate_plan_list == null) {
        this.detail.rate_plan_list = []
      }
    },
    onAddRowInGrid() {
      this.addRate()
    },
    onDeleteIconClicked(data) {
      const idx = data.rowIndex
      this.removeRate(idx)
    },
    textInputChange(params, data, colName) {
      this.detail.rate_plan_list[params.node.rowIndex][colName] = data
    },
    removeRate(index) {
      if (this.detail.rate_plan_list.length > 1) {
        this.detail.rate_plan_list.splice(index, 1)
      }
    },
    addRate() {
      this.detail.rate_plan_list.push({})
    },
    async updateRoom() {
      if (
        this.detail.room_id_hl &&
        (!this.detail.rate_plan_list[0] ||
          !this.detail.rate_plan_list[0].rate_plan_name_hl ||
          !this.detail.rate_plan_list[0].rate_plan_id_hl)
      ) {
        this.$message({
          type: 'error',
          message: 'Không được để trống Rate'
        })
        return
      }
      console.log(this.detail)

      await updateHotelLinkDetail(this.detail)
        .then(data => {
          this.dialogDetailVisible = false
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + data.message)
          })
          this.$emit('attach-data')
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
    }
  }
}
</script>
